const syscoNutrients = [
	'121b7900-cc69-4856-9eba-a3cb123acb8c',
	'18d0e662-703d-4d52-9270-feccef0a0f68',
	'1b240b3e-ec56-4002-bead-a102476f71c3',
	'2710f3bc-8ade-4129-a798-64b92326d963',
	'341e7167-2aa7-47ce-b019-2dd25f6b54a3',
	'374cbf96-8f4f-4ea1-b341-37a288e29905',
	'521a3b99-d852-41cf-bf73-09aa32fc0433',
	'554004d1-c8d5-4906-90b3-36b9d617230d',
	'579dd477-211d-46c3-b20b-d93bfad2b831',
	'58df7653-ba4a-4af8-b499-18bf45481383',
	'6243cb2d-5fdd-43fa-bc47-974cdc6bc5bc',
	'63aab15e-88be-4d10-ac91-c2f192acdf39',
	'66d86085-431f-49d8-afe5-ceb352dad44f',
	'76b86c0c-fc0b-49e9-b589-4b4411138acb',
	'8886a268-5b16-4a6b-9447-224ff52b27c7',
	'94a5feac-805b-4526-b5ce-ec82ba435789',
	'97ed4e16-19bf-4778-bc5a-d1d461002ae7',
	'98c1def0-a4ca-4ddc-9d10-ab3d22c61a6c',
	'991616fb-7efa-4b40-b1d3-c8af66f49dac',
	'9a1029c7-2a27-4767-bc54-4d7041cfd4d6',
	'9c5b0988-db2d-4756-b757-5fedad2648cb',
	'9f454137-9114-4076-b852-bfe822dc8058',
	'a5c3eebe-1df1-4788-8a54-3c454b21ce35',
	'a6b5d693-e129-4ff3-8b50-c1865abb6886',
	'a7b008a7-932d-491c-bd49-ef5d0fe856e9',
	'b1d8d648-10ec-4dc4-96df-d3086f4a788d',
	'ba0fa30f-46bf-477c-9c90-51bf364645ec',
	'ba390924-8ce4-4aae-85e0-43b6968511d5',
	'c35d8a0c-ef9a-46c4-8c1f-8dabc71ce21e',
	'c4e81af1-a23f-422c-aa3c-bff9f701c827',
	'd0d0fce2-c63b-41fd-82b1-4b89d4db8198',
	'd58ba5f1-664f-4995-87e2-6a8d31c29e17',
	'd9086fcb-2ecd-4807-845d-dee9dabefc9d',
	'ddd0fc73-53c5-4915-8259-49824ef025e9',
	'e19d1271-4ff3-4812-951d-4e85e30c679b',
	'e25e67b1-2e04-4c5b-93fa-9e3f42b0fb1b',
	'e88dcd29-8c67-471b-ae22-4fdc6d98b4ba',
	'e992f1fc-6f17-4cc9-ab25-f6ff3d57e623',
	'ebe2a4a6-cebc-4509-9666-d9ece3f1e21c',
	'f3e19784-0ab3-47ac-b17b-72731fbc4476',
	'f8c3fde0-d2ba-4465-9aae-ba0b60fc7c03',
	'f9d1a0b3-af8a-43ee-a37d-96170b8372b1',
	'fe3a239d-a8d6-4478-b8ed-e467d732057c',
];

export default syscoNutrients;
